import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'kon-divider-type',
  standalone: true,
  imports: [CommonModule],
  template: ` <div class="h-px w-full bg-gray-200 mb-1"></div> `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyDividerTypeComponent extends FieldType {}
